module.exports = __webpack_public_path__ + "img/icon-exercise.633ef9ae.png";